/**
 * Извлекает table_id из различных форматов Google Sheets URL
 */
export function extractGoogleSheetId(input: string): string | null {
  const trimmed = input.trim()

  // Если уже похоже на ID (15+ символов, буквы, цифры, дефисы, подчеркивания)
  if (/^[A-Za-z0-9-_]{15,}$/.test(trimmed)) {
    return trimmed
  }

  try {
    const url = new URL(trimmed)

    // Формат /spreadsheets/d/<id>/...
    const dMatch = url.pathname.match(/\/spreadsheets\/d\/([A-Za-z0-9-_]+)/)
    if (dMatch?.[1]) {
      return dMatch[1]
    }

    // Старые ссылки вида ...?key=<id>
    const keyParam = url.searchParams.get('key')
    if (keyParam && /^[A-Za-z0-9-_]{15,}$/.test(keyParam)) {
      return keyParam
    }
  } catch {
    // Не URL, пробуем как ID
    if (/^[A-Za-z0-9-_]{15,}$/.test(trimmed)) {
      return trimmed
    }
  }

  return null
}

/**
 * Валидирует table_id
 */
export function isValidTableId(tableId: string): boolean {
  return /^[A-Za-z0-9-_]{15,}$/.test(tableId)
}
